import { createNcpApiStore } from '@/api'
import { getToday } from '@/utils/dateUtils'
import config from '@/config'

const defaultParams = {
  'pageNumber': 1,
  'pageSize': 10,
  'hasTotalCount': true
}

const apiStore = createNcpApiStore([
  {
    action: '_uploadImages',
    property: 'uploadImagesData',
    path: 'files/images',
    method: 'post'
  },
  {
    action: '_mallsPartners',
    property: 'mallsPartners',
    path: 'malls/partners'
  },
  {
    action: '_malls',
    property: 'malls',
    path: 'malls'
  },
  {
    action: '_fetchAddresses',
    property: 'addresses',
    path: 'addresses/search',
    method: 'get',
    queryParams: true,
    onSuccess (state, payload) {
      state.addresses = [...state.addresses || [], ...payload.data.items]
      state.addresses.totalCount = payload.data.totalCount
    },
    cacheable: false,
    cacheMaxAge: 1000 * 30
  },
  {
    action: '_terms',
    property: 'terms',
    path: 'terms?termsTypes={termsTypes}',
    pathParams: ['termsTypes']
  }
])

export default {
  namespaced: true,
  state: {
    fetchListParams: {},
    totalCount: null,
    loading: true
  },
  mixins: [apiStore],
  actions: {
    uploadImages ({ state, dispatch, commit }, data) {
      return dispatch('_uploadImages', { data })
    },
    async fetchMalls ({ state, dispatch }) {
      let mallInfo = JSON.parse(window.localStorage.mallInfo || null)
      let expiredTime = JSON.parse(window.localStorage.expiredTime || null)
      if (mallInfo && expiredTime && expiredTime === getToday()) {
        state.malls = mallInfo
      } else {
        await dispatch('_malls')
        window.localStorage.mallInfo = JSON.stringify(state.malls)
        window.localStorage.expiredTime = JSON.stringify(getToday())
      }
      // console.log(state.malls.categories.flatCategories[0].depth1Label)
      return state.malls
    },
    fetchMallsPartners ({ state, commit, dispatch }) {
      return dispatch('_mallsPartners')
    },
    fetchAddresses ({ state, dispatch, commit }, params) {
      commit('RESET_LIST')
      commit('SET_PARAMS', {
        'keyword': params.keyword
      })
      return dispatch('_fetchAddresses', { params: state.fetchListParams })
    },
    fetchAddressesMore ({ state, dispatch, commit, rootState }, payload) {
      commit('SET_PARAMS', {
        pageNumber: (state.fetchListParams.pageNumber + 1)
      })
      return dispatch('_fetchAddresses', { params: state.fetchListParams }).then(() => {
        if (state.addresses.length >= state.addresses.totalCount) {
          state.loading = false
        }
      })
    },
    getTerms ({ state, commit, dispatch }, termsTypes) {
      return dispatch('_terms', { params: { termsTypes } })
    }
  },
  getters: {
    flatCategories (state) {
      if (state.malls) {
        const result = state.malls.categories.flatCategories.filter(category => config.navCagetories.indexOf(category.depth1CategoryNo.toString()) !== -1)
        result.forEach(item => {
          if (item.depth1CategoryNo.toString() === config.navCagetories[0]) {
            item.iconColor = 'yellow'
          } else if (item.depth1CategoryNo.toString() === config.navCagetories[1]) {
            item.iconColor = 'blue'
          } else if (item.depth1CategoryNo.toString() === config.navCagetories[2]) {
            item.iconColor = 'purple'
          } else {
            item.iconColor = 'green'
          }
        })
        return result
      }
    },
    productInquiryTypes (state) {
      if (state.malls) {
        return state.malls.productInquiryType
      }
      return null
    },
    productReviewReportTypes (state) {
      if (state.malls) {
        return state.malls.productReviewReportType.reverse()
      }
      return null
    },
    inquiryTypes (state) {
      if (state.malls) {
        return state.malls.inquiryType
      }
      return null
    },
    claimReasonTypes (state) {
      if (state.malls) {
        return state.malls.claimReasonType
      }
      return null
    },
    orderStatusTypes (state) {
      if (state.malls) {
        return state.malls.orderStatusType
      }
      return null
    },
    footerInfo (state) {
      if (state.malls) {
        let businessNo = state.malls.serviceBasicInfo.businessRegistrationNo
        businessNo = businessNo.substr(0, 3) + '-' + businessNo.substr(3, 2) + '-' + businessNo.substr(5)
        return {
          phoneNo: state.malls.mall.serviceCenter.phoneNo,
          email: state.malls.mall.serviceCenter.email,
          companyName: state.malls.serviceBasicInfo.companyName,
          businessRegistrationNo: businessNo,
          representativeName: state.malls.serviceBasicInfo.representativeName,
          onlineMarketingBusinessDeclarationNo: state.malls.serviceBasicInfo.onlineMarketingBusinessDeclarationNo,
          zipCd: state.malls.serviceBasicInfo.zipCd,
          address: state.malls.serviceBasicInfo.address,
          addressDetail: state.malls.serviceBasicInfo.addressDetail,
          mallName: state.malls.mall.mallName,
          privacyManagerName: state.malls.serviceBasicInfo.privacyManagerName
        }
      }
    },
    accumulationConfig (state) {
      if (state.malls) {
        return state.malls.accumulationConfig
      }
      return null
    }
  },
  mutations: {
    SET_PARAMS (state, params) {
      state.fetchListParams = {
        ...state.fetchListParams,
        ...params
      }
    },
    RESET_LIST (state) {
      state.addresses = null
      state.totalCount = 0
      state.loading = true
      state.fetchListParams = defaultParams
    }
  }
}
